import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("button", {
  id: "kt_explore_toggle",
  class: "\n      btn btn-sm btn-white btn-active-primary\n      shadow-sm\n      position-fixed\n      px-5\n      fw-bolder\n      zindex-2\n      top-50\n      mt-10\n      end-0\n      transform-90\n      fs-6\n    ",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "right",
  "data-bs-trigger": "hover"
}, [
  /*#__PURE__*/_createVNode("span", { id: "kt_explore_toggle_label" }, "Explore")
], -1)
const _hoisted_2 = {
  id: "kt_explore",
  class: "bg-body",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "explore",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'350px', 'lg': '475px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_explore_toggle",
  "data-kt-drawer-close": "#kt_explore_close"
}
const _hoisted_3 = { class: "card shadow-none w-100" }
const _hoisted_4 = {
  class: "card-header",
  id: "kt_explore_header"
}
const _hoisted_5 = { class: "card-title fw-bolder text-gray-700" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-active-light-primary me-n5",
  id: "kt_explore_close"
}
const _hoisted_8 = { class: "svg-icon svg-icon-2" }
const _hoisted_9 = {
  class: "card-body",
  id: "kt_explore_body"
}
const _hoisted_10 = {
  id: "kt_explore_scroll",
  class: "scroll-y me-n5 pe-5",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_explore_body",
  "data-kt-scroll-dependencies": "#kt_explore_header",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-7\"><div class=\"d-flex flex-stack\"><h3 class=\"mb-0\">Metronic Licenses</h3><a href=\"https://themeforest.net/licenses/standard\" class=\"fw-bold\" target=\"_blank\"> License FAQs </a></div></div><div class=\"\n                rounded\n                border border-dashed border-gray-300\n                py-4\n                px-6\n                mb-5\n              \"><div class=\"d-flex flex-stack\"><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center mb-1\"><div class=\"fs-6 fw-bold text-gray-800 fw-bold mb-0 me-1\"> Regular License </div><i class=\"text-gray-400 fas fa-exclamation-circle ms-1 fs-7\" data-bs-toggle=\"popover\" data-bs-custom-class=\"popover-dark\" data-bs-trigger=\"hover\" data-bs-placement=\"top\" data-bs-content=\"Use, by you or one client in a single end product which end users are not charged for.\"></i></div><div class=\"fs-7 text-muted\"> For single end product used by you or one client </div></div><div class=\"text-nowrap\"><span class=\"text-muted fs-7 fw-bold\">$</span><span class=\"text-dark fs-1 fw-bolder\">39</span></div></div></div><div class=\"\n                rounded\n                border border-dashed border-gray-300\n                py-4\n                px-6\n                mb-5\n              \"><div class=\"d-flex flex-stack\"><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center mb-1\"><div class=\"fs-6 fw-bold text-gray-800 fw-bold mb-0 me-1\"> Extended License </div><i class=\"text-gray-400 fas fa-exclamation-circle ms-1 fs-7\" data-bs-toggle=\"popover\" data-bs-custom-class=\"popover-dark\" data-bs-trigger=\"hover\" data-bs-placement=\"top\" data-bs-content=\"Use, by you or one client, in a single end product which end users can be charged for.\"></i></div><div class=\"fs-7 text-muted\"> For single end product with paying users. </div></div><div class=\"text-nowrap\"><span class=\"text-muted fs-7 fw-bold\">$</span><span class=\"text-dark fs-1 fw-bolder\">939</span></div></div></div><div class=\"\n                rounded\n                border border-dashed border-gray-300\n                py-4\n                px-6\n                mb-5\n              \"><div class=\"d-flex flex-stack\"><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center mb-1\"><div class=\"fs-6 fw-bold text-gray-800 fw-bold mb-0 me-1\"> Custom License </div></div><div class=\"fs-7 text-muted\"> Reach us for custom license offers. </div></div><div class=\"text-nowrap\"><a href=\"https://keenthemes.com/contact/\" class=\"btn btn-sm btn-success\" target=\"_blank\">Contact Us</a></div></div></div><a href=\"https://themeforest.net/item/metronic-responsive-admin-dashboard-template/4021469\" class=\"btn btn-primary mb-15 w-100\"> Buy Now </a>", 5)
const _hoisted_17 = { class: "mb-0" }
const _hoisted_18 = { class: "fw-bolder text-center mb-6" }
const _hoisted_19 = { class: "row g-5" }
const _hoisted_20 = { class: "overlay-wrapper" }
const _hoisted_21 = { class: "overlay-layer bg-dark bg-opacity-10" }
const _hoisted_22 = {
  key: 1,
  class: "\n                            badge badge-white\n                            px-6\n                            py-4\n                            fw-bold\n                            fs-base\n                            shadow\n                          "
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h3", _hoisted_5, _toDisplayString(_ctx.themeName) + " Metronic ", 1),
          _createVNode("div", _hoisted_6, [
            _createVNode("button", _hoisted_7, [
              _createVNode("span", _hoisted_8, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode("div", _hoisted_17, [
                _createVNode("h3", _hoisted_18, _toDisplayString(_ctx.themeName) + " Demos", 1),
                _createVNode("div", _hoisted_19, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.demos, (item, i) => {
                    return (_openBlock(), _createBlock("div", {
                      key: i,
                      class: "col-6"
                    }, [
                      _createVNode("div", {
                        class: `overlay overflow-hidden position-relative ${
                        _ctx.demo === item.name
                          ? 'border border-4 border-success'
                          : 'border border-4 border-gray-200'
                      } rounded`
                      }, [
                        _createVNode("div", _hoisted_20, [
                          _createVNode("img", {
                            src: `media/demos/${item.name}.png`,
                            alt: "demo",
                            class: `w-100 ${!item.available && 'opacity-75'}`
                          }, null, 10, ["src"])
                        ]),
                        _createVNode("div", _hoisted_21, [
                          (item.available)
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                href: `https://preview.keenthemes.com/metronic8/vue/${item.name}`,
                                class: "btn btn-sm btn-success shadow"
                              }, _toDisplayString(item.name.charAt(0).toUpperCase() +
                            item.name.slice(1)), 9, ["href"]))
                            : (_openBlock(), _createBlock("div", _hoisted_22, " Coming soon "))
                        ])
                      ], 2)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}